/*global _ */
import axiosNoAuth from 'axios'
import {fv, pluck} from '../lib/formatters'

import Base, {
  axios,
  setPromise,
  getEndpoint,
  loadCache,
  omitId,
  payloads
} from './base'

export {
  APIURI,
  client_secret,
  client_id,
  getFirstErrorMessage,
  getErrorMessage,
  getErrorMessages,
  getErrorMessagesWithKeys,
  endpoints,
  services,
  handlePromise,
  promise,
  setPromise,
  getEndpoint,
} from './base'

export const list = async (options = {}) => {
  options = options || {}
  const key = fv(options.key, 'name')
  const paths = options.paths || 'display_name'
  const keyMap = options.keyMap || null
  try {
    const locations = await read()
    if (options.full) {
      return _.mapKeys(locations, location => location.id)
    }
    return pluck(locations || {}, key, paths, keyMap)
  } catch (e) {
    //
  }
  return []
}
setPromise('locations.list', list)

setPromise('locations.listBy.id', async () => {
  let locations = _.get(window, 'addiesaas.locations')
  if (!locations) {
    // Get caches data
    locations = await loadCache('locations', () => list({key: 'id'}))
  } else {
    return _.mapValues(locations, location => _.isString(location) ? location : _.get(location, 'display_name'))
  }
  return locations
})

export const read = async () => {
  const endPoint = getEndpoint('locations.read', {}, '/customer/location')
  const payload = {page_size: 9999, ..._.get(payloads, 'locations.read', {})}
  const {data = {}} = await axiosNoAuth.get(endPoint, {params: payload})
  return data.data || []
}
setPromise('locations.read', read)

const myServices = {read, list}

export default {
  ...Base,
  ...myServices
}
